module.exports = __webpack_public_path__ + "static/img/img_kaifaanli1.f2e70a56.png";